<template>
    <div>
        <AppNavbar />
        <PagesHero :breadcrumbData="{
            title: $t('about_us.title'),
            subtitle: {
                first_text: $t('about_us.label'),
                first_href: '/',
                second_text: $t('about_us.title')
            }
        }" />
        <div class="container">
            <div class="row align-items-center">

                <div class="col-lg-6 col-12">
                    <h2>{{ $t('about_us.title') }}</h2>
                    <p>{{ $t('about_us.paragraph1') }}</p>
                    <p class="mt-0">{{ $t('about_us.paragraph2') }}</p>
                </div>
                <div class="col-lg-6 col-12">
                    <div class="image-container">
                        <img src="@/assets/images/home/aboutus/image3.webp" class="img" />
                    </div>
                </div>
            </div>
            <div class="row align-items-center">
                <div class="col-lg-6 col-12 order-lg-1 order-2">
                    <div class="image-container">
                        <img src="@/assets/images/home/aboutus/image4.webp" class="img" />
                    </div>
                </div>
                <div class="col-lg-6 col-12 order-lg-2 order-1">
                    <h2>{{ $t('about_us.general_goals') }}</h2>
                    <ul>
                        <li>{{ $t('about_us.li1') }}</li>
                        <li>{{ $t('about_us.li2') }}</li>
                        <li>{{ $t('about_us.li3') }}</li>
                        <li>{{ $t('about_us.li4') }}</li>

                    </ul>
                </div>
            </div>
            <div class="row justify-content-center" style="margin-top: 60px;">
                <div class="col-lg-6 col-12">

                    <FramedCard :title="$t('about_us.vision')"
                        :content="`<li>${$t('about_us.vision_paragraph')}</li>`" :centeredFrame="false"/>

                </div>
                <div class="col-lg-6 col-12">

                    <FramedCard :title="$t('about_us.message')"
                        :content="`<li>${$t('about_us.message_paragraph')}</li>`" :centeredFrame="false"/>
                </div>

            </div>
        </div>
        <AppFooter />
    </div>
</template>

<script>
import AppNavbar from '@/components/AppNavbar.vue';
import AppFooter from '@/components/AppFooter.vue';
import PagesHero from '@/components/PagesHero.vue';
import FramedCard from '@/components/FramedCard.vue';

export default {
    components: {
        AppFooter, AppNavbar, PagesHero, FramedCard
    }
}
</script>

<style scoped>
.row {
    margin-top: 40px;
}

.image-container {
    position: relative;
    display: inline-block;
    border-radius: 20px;
    overflow: hidden;
}

.img {
    width: 100%;
    height: 391px;
    object-fit: cover;
    border-radius: 20px;
}

h2 {
    font-size: 36px;
    font-weight: 500;
    margin-bottom: 20px;
}

p:nth-of-type(1) {
    margin-bottom: 0;
}

p {
    font-size: 22px;
    font-weight: 400;
}




.about-box {
    position: relative;
    padding: 50px;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: right;
    border-radius: 15px;
    border: 2px solid #c8a15a;
    margin-top: 60px;
    /* Add margin to accommodate the header */
}

.about-header {
    position: absolute;
    top: -50px;
    /* Adjust this value to position the header above the box */
    right: -5%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 5px 20px;
    border-radius: 20px;
    font-weight: bold;
    color: white;
    font-size: 1.1rem;
}

.absloute_image {
    width: 120px;
    height: 80px;
    object-fit: contain;
    position: relative;
    /* Ensure the image is positioned relative to the header */
    z-index: -1;
    /* Place the image behind the text */
}

.about-title {
    position: absolute;
    top: 50%;
    /* Center the text vertically */
    left: 50%;
    /* Center the text horizontally */
    transform: translate(-50%, -50%);
    /* Perfectly center the text */
    z-index: 1;
    /* Ensure the text is above the image */
}


.container {
    padding-bottom: 80px;
}
</style>